import { z } from 'zod'

export const paramsSchema = z.object({
  slug: z.string(),
  province: z.string(),
})

export type paramsType = z.infer<typeof paramsSchema>
